import { scroll } from '@/lib/scroll';
import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';

export function useScrollToAnchor() {
  useIsomorphicLayoutEffect(() => {
    const path = window.location.hash;

    if (path && path.includes(`#`)) {
      setTimeout(() => {
        const id = path.replace(`#`, ``);
        const element = window.document.getElementById(id);
        const rect = element && element.getBoundingClientRect();

        if (rect) {
          scroll({
            top: window.scrollY + rect.top - 95, // header size (80px) + 15px
          });
        }
      }, 600);
    }
  }, []);

  return {};
}
